/**
 * Enumeration class for Status
 */
export enum Status {
    
        "Novo usuário"
        
    
}
